// Verbatim from Hedge-Fund-Tracking-System apps/web/src/components/layout/theme-toggle.tsx,
// with `useTheme` re-pointed at our local ThemeProvider (same shape as next-themes).
import { Sun, Moon } from 'lucide-react';
import { cn } from '../../lib/utils';
import { useTheme } from './theme-provider';

interface ThemeToggleProps {
  className?: string;
}

export function ThemeToggle({ className }: ThemeToggleProps) {
  const { resolvedTheme, setTheme } = useTheme();

  return (
    <button
      onClick={() => setTheme(resolvedTheme === 'dark' ? 'light' : 'dark')}
      className={cn(
        'h-9 w-9 rounded-md flex items-center justify-center',
        'text-muted-foreground hover:text-foreground hover:bg-accent transition-colors',
        className,
      )}
      aria-label="Toggle theme"
    >
      {resolvedTheme === 'dark' ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
    </button>
  );
}
